import { AnimatedDiv } from "@client/content/hocs/animate";
import Icon from "@client/controls/Icon/component";
import { type AnimationOptions } from "@client/lib/jquery/animate";
import type { EntityRef } from "@client/types";
import { type EntityContainerProps } from "@client/viewer/layout/Entity/Container/container";
import EntityContainer from "@client/viewer/layout/Entity/container";
import classNames from "classnames";
import * as React from "react";

import "./style.less";

export interface ActionProps {
  close: () => void;
}

export type MapProps = EntityRef & {
  animationOptions: AnimationOptions;
  canClose: boolean;
  className?: string;
  closeButtonIcon?: string;
  closeButtonStyle: React.CSSProperties;
  entityStyle?: React.CSSProperties;
  style: React.CSSProperties;
  EntityContainer?: React.ComponentType<EntityContainerProps>;
};

const Popup = (props: MapProps & ActionProps) => {
  const Container = props.EntityContainer ?? EntityContainer;

  return (
    <AnimatedDiv
      animationOptions={props.animationOptions}
      className={classNames("wsc_popup", props.className)}
      style={props.style}
      onClick={(e) => e.stopPropagation()}
    >
      {!!props.closeButtonIcon && (
        <Icon
          className="close"
          onClick={props.canClose ? props.close : undefined}
          style={props.closeButtonStyle}
          iconClassName={props.closeButtonIcon}
        />
      )}

      <Container id={props.id} source={props.source} style={props.entityStyle} />
    </AnimatedDiv>
  );
};
export default Popup;
